"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=(e,t)=>e?"boolean"==typeof e?t:Object.entries(e).filter((e=>{let[t,r]=e;return r})).map((e=>{let[r]=e;return"".concat(t,"-").concat(r)})).join(" "):"";
